import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.target = this.DOM.view.querySelector(
      this.DOM.view.getAttribute("data-selector")
    );

    //
    this.FX = {
      text: new SplitText(this.DOM.target, {
        type: "lines",
      }),
      textChildren: new SplitText(this.DOM.target, {
        type: "lines",
        linesClass: "tw-overflow-hidden",
      }),
    };

    this.animate();
    this.listener();
  }

  animate() {
    this.animation = gsap.timeline({
      onComplete: () => {
        // this.FX.textChildren.revert();
        // this.FX.text.revert();
      },
    });

    this.animation.add([
      gsap.fromTo(
        this.FX.text.lines,
        {
          y: "100%",
        },
        {
          y: 0,
          ease: "quint.out",
          duration: 0.6,
          stagger: 0.1,
        }
      ),
    ]);
  }

  listener() {
    this.stListener = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: this.DOM.view.getAttribute("data-start"),
      animation: this.animation,
    });
  }

  unmount() {
    this.stListener.kill();
  }
}
